import React from 'react';
import { AddSectionButton } from '../AddSectionButton';
import { IconButton } from '../../../../components/IconButton';

interface PropTypes {
  onAddSection: () => void;
}

export function SectionListHeader(props: PropTypes) {
  return (
    <div className='d-flex align-items-center'>
      <div className='me-auto'>
        <div className='fs-3 fw-semibold'>Sections</div>
        <div className='fs-5 text-dark-200'>
          Define and manage your scorecard sections
        </div>
      </div>
      <div className='d-flex gap-3'>
        <IconButton
          color='secondary'
          iconName='bi-eye'
          buttonText='Preview'
          onClick={() => {}}
          disabled={true}
        />
        <AddSectionButton border={true} onClick={props.onAddSection} />
      </div>
    </div>
  );
}
